import React from 'react';
import InfoTabs from '../informationTab/components/infoTabs';

const CommerceServicesTab = () => <InfoTabs menuCode="commerce_services"/>;

export default CommerceServicesTab;
